import moment from 'moment';
import axios from "axios";

function getFirstBrowserLanguage() {
  const nav = window.navigator;
  const languageKeys = ["languages", "language", "browserLanguage", "systemLanguage", "userLanguage"];

  for (const key of languageKeys) {
    const language = nav[key];
    if (Array.isArray(language)) {
      return language.find((l) => l.length > 2);
    } else if (language && language.length > 2) {
      return language;
    }
  }

  return null;
}

export function getUserLanguage() {
  const lang = getFirstBrowserLanguage();
  const separatorIndex = lang.indexOf('-');
  return separatorIndex !== -1 ? lang.substring(separatorIndex + 1).toLowerCase() : lang;
}

export function requestMetaConversionAPI(storeName) {
  
  let data = [
    {
        "event_name": "openStore",
        "event_time": moment().unix(),
        "action_source": "website",
        "user_data": {
            "madid": storeName
        }
    }
];




axios.post(`https://graph.facebook.com/v20.0/${process.env.REACT_APP_PIXEL_ID}/events?access_token=${process.env.REACT_APP_META_API_TOKEN}`, {
    data
})
}


export function LanguageDetector() {
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const detectedLang = pathParts.find(part => /^[a-z]{2}$/i.test(part));

  return detectedLang || getUserLanguage();
}

axios.defaults.headers.common["language"] = LanguageDetector();
axios.defaults.headers.common["component"] = "webclient";